// extracted by mini-css-extract-plugin
export default {"link":"wXb2Ef","as-button":"EUN6nH","asButton":"EUN6nH"};